import React from 'react';
import {calculaPrevision, formatMs, getControlById} from '../utils/time';

const ResultadoDetailTablaPasos = ({resultado, prevision, competicion, controlList, sectores}) => {
  let ultimoSector = null
  if (sectores && sectores.length) {
    sectores.forEach(sector => {
      sector.fin_metros = 0
      sector.inicio_metros = 0
      if (sector.inicio) {
        const inicio = getControlById(controlList, sector.inicio)
        if (inicio) {
          sector.incio_control = inicio
          sector.inicio_metros = inicio.distancia
        }
      }
      const fin = getControlById(controlList, sector.fin)
      if (fin) {
        sector.fin_control = fin
        sector.fin_metros = fin.distancia
      }
    })
  }

  const _getSectorActual = (control) => {
    return sectores.find(sector => sector.inicio_metros < control.distancia && sector.fin_metros >= control.distancia)
  }

  if (controlList) {
    return <div className={'resultado__tabla-container'}>
      <table className={'resultado__tabla'}>
        <thead>
          <tr>
            <th className={'text-left'}>
              Control
            </th>
            <th className={'text-right'}>
              Pos
            </th>
            <th className={'text-right'}>
              Tiempo
            </th>
            <th className={'text-right'}>
              Ritmo
            </th>
          </tr>
        </thead>
        <tbody>
          {controlList.map((control) => {
            const tiempo = resultado[ 'control_' + control.id + '_tiempo' ]
            const puesto = resultado[ 'control_' + control.id + '_puesto' ]

            let estaPrevision = null
            if (sectores && sectores.length) {
              // Unicamente calculamos previsións para o sector actual
              let d0 = 0
              let d1 = 0
              if (prevision.sector && prevision.sector.inicio) {
                const inicio = getControlById(controlList, prevision.sector.inicio)
                if (inicio) {
                  d0 = inicio.distancia
                }
              }
              if (prevision.sector) {
                const fin = getControlById(controlList, prevision.sector.fin)
                if (fin) {
                  d1 = fin.distancia
                }
              }
              if (d0 <= control.distancia && d1 >= control.distancia) {
                if (prevision.control && prevision.control.id === control.id) {
                  estaPrevision = prevision
                } else {
                  if (control.prevision) {
                    estaPrevision = calculaPrevision(competicion, controlList, sectores, resultado, control)
                  }
                }
              }
            } else {
              if (prevision.control && prevision.control.id === control.id) {
                estaPrevision = prevision
              } else {
                if (control.prevision) {
                  estaPrevision = calculaPrevision(competicion, controlList, sectores, resultado, control)
                }
              }
            }

            let ritmo = tiempo ? formatMs(tiempo / control.distancia * 1000) : '---'

            let ritmoTiempo = tiempo
            let trHeaderSector = null
            if (sectores && sectores.length) {
              const sector = _getSectorActual(control)
              if (sector) {
                if (tiempo) {
                  if (sector.inicio && resultado['control_' + sector.inicio + '_tiempo']) {
                    ritmoTiempo = tiempo - resultado['control_' + sector.inicio + '_tiempo']
                  }

                  if (sector.resultados_ritmo) {
                    let ritmoDistancia = control.distancia
                    if (sector.inicio) {
                      ritmoDistancia = control.distancia - sector.inicio_metros
                      // tiempo = ritmoTiempo
                    } else if (!sector.incio_control) {
                      // Se non hai control de inicios pensamos que desde a salida.
                    } else {
                      ritmo = '---'
                      ritmoTiempo = 0
                    }

                    if (ritmoTiempo) {
                      if (sector.resultados_ritmo === 'RUNNING') {
                        ritmo = formatMs(ritmoTiempo / ritmoDistancia * 1000) + ' min/km'
                      } else if (sector.resultados_ritmo === 'BICI') {
                        ritmo = (ritmoDistancia / (ritmoTiempo / 60 / 60)).toFixed(2) + ' km/h'
                      } else if (sector.resultados_ritmo === 'NATACION') {
                        ritmo = formatMs(ritmoTiempo / ritmoDistancia * 100) + ' min/100m'
                      }
                    }
                  } else {
                    ritmo = '---'
                  }
                }
                if (!ultimoSector || sector.id !== ultimoSector.id) {
                  let tiempoEnSector = 0
                  if (sector.fin && resultado['control_' + sector.fin + '_tiempo']) {
                    tiempoEnSector = resultado['control_' + sector.fin + '_tiempo']
                  }
                  if (sector.inicio && resultado['control_' + sector.inicio + '_tiempo']) {
                    tiempoEnSector -= resultado['control_' + sector.inicio + '_tiempo']
                  }
                  // console.info(sector)
                  /*
                  let ritmoEnSector = ''
                  if (tiempoEnSector && 'inicio_metros' in sector && 'fin_metros' in sector) {
                    let distaciaEnSector = sector.fin_metros - sector.inicio_metros
                    if (sector.resultados_ritmo === 'RUNNING') {
                      ritmoEnSector = formatMsShort(tiempoEnSector / distaciaEnSector * 1000) + ' min/km'
                    } else if (sector.resultados_ritmo === 'BICI') {
                      ritmoEnSector = (distaciaEnSector / (tiempoEnSector / 60 / 60)).toFixed(2) + ' km/h'
                    } else if (sector.resultados_ritmo === 'NATACION') {
                      ritmoEnSector = formatMsShort(tiempoEnSector / distaciaEnSector * 100) + ' min/100m'
                    }
                  }
                  */

                  trHeaderSector = <tr key={`sector-${sector.id}`}>
                    <td colSpan={4} className='resultado__sector-table-header'>
                      <b>{sector.nombre}:</b>
                      {tiempoEnSector > 0 &&
                        <span style={{color: 'white'}}>&nbsp;&nbsp;
                          { formatMs(tiempoEnSector) }
                          {/* ritmoEnSector && <small> @{ ritmoEnSector }</small> */}
                        </span>
                      }
                    </td>
                  </tr>
                  ultimoSector = sector
                }
              }
            } else {
              if (competicion.resultados_ritmo && tiempo) {
                if (competicion.resultados_ritmo === 'RUNNING') {
                  ritmo = formatMs(tiempo / control.distancia * 1000) + ' min/km'
                } else if (competicion.resultados_ritmo === 'BICI') {
                  ritmo = (control.distancia / (tiempo / 60 / 60)).toFixed(2) + ' km/h'
                } else if (competicion.resultados_ritmo === 'NATACION') {
                  ritmo = formatMs(tiempo / control.distancia * 100) + ' min/100m'
                }
              }
            }

            return <React.Fragment key={control.id}>
              {trHeaderSector}
              <tr key={control.id}>
                <td>
                  {control.nombre} <br /><span className={'small-text'}>{control.descripcion}</span>
                </td>
                <td className={'text-right '}>
                  {puesto || '---'}
                </td>
                <td className={'text-right'}>
                  {tiempo ? (
                    <span>{formatMs(tiempo)}</span>
                  ) : (
                    (estaPrevision && estaPrevision.tiempoTotal) ? (
                      <span>{formatMs(estaPrevision.tiempoTotal)}
                        <small><br />(previsión)</small></span>
                    ) : (
                      <span>---</span>
                    )
                  )}
                </td>
                <td className={'text-right'}>
                  {ritmo}
                </td>
              </tr>
            </React.Fragment>
          })}
        </tbody>
      </table>
    </div>
  } else {
    return <div />
  }
}

export default ResultadoDetailTablaPasos



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailTablaPasos.js